<template>
  <form data-vv-scope="keywords-form" class="bg-white shadow rounded-lg mt-10 pt-4 pb-10">
    <b-alert variant="info" class="m-5" show>
      <div class="alert-body">
        <span class="text-sm text-gray-600">
          * Pincha sobre el candado para activar/desactivar esta sección.
        </span>
      </div>
    </b-alert>
    <!-- header -->
    <div class="px-2 py-2 pr-md-4 pl-md-4 ml-md-5 mr-md-5 justify-content-between d-flex">
      <span class="text-base leading-6 font-medium text-gray">
        Palabras Clave <span class="badge badge-secondary">{{ elementKeywords.length }}</span>
      </span>
      <b-button
        @click="disabled = !disabled"
        :variant="disabled ? 'flat-danger' : 'flat-success'"
        class="btn-icon rounded-circle cursor-pointer border-none"
        :class="{
          'cursor-not-allowed': userPermissions.write === 0
            && userPermissions.totalControl === 0
            && !hasPermission('FEB99')
        }"
        :disabled="userPermissions.write === 0
          && userPermissions.totalControl === 0
          && !hasPermission('FEB99')"
      >
        <transition enter-active-class="animated fadeIn">
          <feather-icon v-if="disabled" icon="LockIcon"/>
        </transition>
        <transition enter-active-class="animated fadeIn">
          <feather-icon v-if="!disabled" icon="UnlockIcon"/>
        </transition>
      </b-button>
    </div>
    <!-- body -->
    <div class="border-t border-gray-200 m-5">
      <v-select
        v-if="!disabled"
        v-model="elementKeywords"
        placeholder="Selecciona una o mas Palabras Clave existentes o crea una nueva."
        :options="keywordOptions"
        taggable
        multiple
        @option:selecting="addKeyword"
        @option:selected="removeFails"
        @option:deselecting="deleteKeyword"
      >
        <template #search="{attributes, events}">
          <input
            name="keywords"
            data-vv-as="Palabras Clave"
            class="vs__search"
            v-validate="'alpha_num'"
            v-bind="attributes"
            v-on="events"
            :danger-message="errors.has('keywords-form.keywords')"
          />
        </template>
        <div slot="no-options">No existen opciones para seleccionar.</div>
      </v-select>
      <div v-else-if="elementKeywords.length" class="card">
        <div class="card-body">
          <b-badge
            class="cursor-not-allowed mr-3"
            v-for="(keyword, index) in elementKeywords"
            variant="light-secondary"
            :key="`keyword_${index}`"
          >
            {{ keyword }}
          </b-badge>
        </div>
      </div>
      <FormError
        attributeName="keywords-form.keywords"
        :errorsForm="errors"
      />
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';

import FormError from '@/febos/global/documentManagement/components/FormError';
import {
  ioEDFilesKeywordsAdd,
  ioEDFilesKeywordsDelete,
  ioEDFilesKeywordsList
} from '@/febos/servicios/api/repositories.api';

export default {
  name: 'EDKeywordsForm',
  data() {
    return {
      userPermissions: {
        read: 0,
        write: 0,
        totalControl: 0
      },
      keywordOptions: [],
      elementKeywords: [],
      disabled: true
    };
  },
  components: {
    FormError
  },
  mounted() {
    this.elementKeywords = this.getSelectedElement.keywords;
    this.loadPermissions();
  },
  methods: {
    async loadKeywordOptions() {
      const response = await ioEDFilesKeywordsList({
        orden: encodeURIComponent('+palabra'),
        campos: 'archivo_id,palabra',
        itemsPorPagina: '1000',
        pagina: '1'
      });
      this.keywordOptions = response.data.keywords;
    },
    async addKeyword(keyword) {
      if (this.errors.all().length) {
        return;
      }
      await ioEDFilesKeywordsAdd({
        keyword,
        fileId: this.getSelectedElement.id,
        repositoryId: this.getSelectedElement.repositoryId
      });
    },
    async deleteKeyword(keyword) {
      await ioEDFilesKeywordsDelete({
        keywords: keyword,
        fileId: this.getSelectedElement.id,
        repositoryId: this.getSelectedElement.repositoryId
      });
    },
    async removeFails() {
      if (this.errors.all().length) {
        this.elementKeywords.pop();
      }
    },
    loadPermissions() {
      const selected = this.getSelectedElement;
      this.userPermissions.read = selected.loggedUserPermissions.lectura;
      this.userPermissions.write = selected.loggedUserPermissions.escritura;
      this.userPermissions.totalControl = selected.loggedUserPermissions.controlTotal;
    }
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser',
      'hasPermission'
    ]),
    ...mapGetters('DocManagement', [
      'getSelectedFolderId',
      'getSelectedElement',
      'getPermissionsStack'
    ])
  },
  watch: {
    getSelectedElement() {
      this.disabled = true;
      this.elementKeywords = this.getSelectedElement.keywords;
      this.loadPermissions();
    }
  }
};
</script>
